<mat-card>
    <h4 class="headingfirst">Contact Us</h4>
    <form>
        <mat-card-content>
            <div class="main"></div>
            <div class="row box">
                <div class="col-md-6 col-sm-6">
                    <div class="row">
                        <div class="col-md-9 col-sm-9">
                        <mat-form-field>
                            <mat-label>Restuarant Name</mat-label>
                            <input matInput name="name" [(ngModel)]="contactUs[0].name">
                        </mat-form-field>
                    </div>
                   <div class="col-md-9 col-sm-9">
                    <mat-form-field>
                        <mat-label>Mobile No</mat-label>
                        <input matInput placeholder="Mobile No" name="phone" [(ngModel)]="phone">
                    </mat-form-field>
                   </div>
                   <div class="col-md-3 col-sm-3">
                       <button (click)="add('mobile')" class="add">ADD</button>
                   </div>
                   <div class="col-md-9 col-sm-9">
                       <ng-container *ngFor="let mobile of contactUs[0].phoneNo">
                  <p class="text">{{mobile}} <span class="material-icons del" (click)="delete(mobile,'mobile')">delete</span></p>
                </ng-container>
                   </div>
                   <div class="col-md-9 col-sm-9">
                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput placeholder="Email" name="email" [(ngModel)]="email">
                    </mat-form-field>
                   </div>
                   <div class="col-md-3 col-sm-3">
                    <button (click)="add('email')" class="add">ADD</button>
                </div>
                   <div class="col-md-9 col-sm-9">
                    <ng-container *ngFor="let email of contactUs[0].email">
                    <p class="text">{{email}} <span class="material-icons del" (click)="delete(email,'email')">delete</span></p>
  </ng-container>
                     </div>
                     <div class="col-md-9 col-sm-9">
                        <mat-form-field>
                            <mat-label>Address</mat-label>
                            <input matInput placeholder="Address" name="address" [(ngModel)]="address">
                        </mat-form-field>
                       </div>
                       <div class="col-md-3 col-sm-3">
                        <button (click)="add('address')" class="add">ADD</button>
                    </div>
                       <div class="col-md-9 col-sm-9">
                        <ng-container *ngFor="let address of contactUs[0].address">
                        <p class="text">{{address}}<span class="material-icons del" (click)="delete(address,'address')">delete</span></p>
                        </ng-container>
      
                         </div>
                </div>
            
            
            </div>
            <div class="col-md-6 col-sm-6">
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <ng-container *ngIf="!contactUs[0].bannerImage.url;else image3">
                            <label class="custom">
                                Banner Image
                                <input type="file" accept="image/*" (change)="uploadSingle($event)"  hidden>
                            </label></ng-container>
                            <ng-template #image3>
                                <img src="{{contactUs[0].bannerImage.url}}" class="logo" >
                                
                        <a (click)="deleteAboutImage(contactUs[0].bannerImage)" class="deleteicon mat-raised-button">Delete</a>
                            </ng-template>
                    </div>
                </div>
            </div>
                </div>
        </mat-card-content>
        <div class="row actions">
            <mat-card-actions class="action">
                <button (click)="back()" mat-button>Back</button>
                <button  (click)="UpdateContent(contactUs[0].id,contactUs[0])" mat-button>Edit</button>
            </mat-card-actions>
        </div>
    </form>
</mat-card>